import { render } from "./Header.vue?vue&type=template&id=347fe2e4&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=347fe2e4&lang=less&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=347fe2e4&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347fe2e4"]])

export default __exports__